import Vue from 'vue';
import _ from 'lodash';
import { editorToolTips } from './tooltips';
import { editorTabs } from './tabs';
import { nestable } from './nestable';
import { drzDragula } from './dragula';
import { bubbles } from './bubbles';

export function Tooltip() {
  Vue.directive('tooltip', {
    inserted(el, tip) {
      editorToolTips.init(el, tip);
    },
  });
}

export function Nestable() {
  Vue.directive('nestable', {
    inserted(el, binding, vnode) {
      nestable.init(el, binding, vnode);
    },
    componentUpdated(el, binding, vnode) {
      // rerun on updates
      nestable.init(el, binding, vnode);
    },
  });
}

export function Tabs() {
  Vue.directive('tabs', {
    inserted(el, binding) {
      editorTabs.init(el, binding);
    },
  });
}

export function DropletBubbles() {
  Vue.directive('droplet-bubble', {
    // To calculate the bubble location on page
    componentUpdated(el) {
      bubbles.init(el);
    },
  });
}

export function Dragula() {
  const vnodes = [];
  Vue.directive('drz-dragula', {
    inserted(el, binding, vnode) {
      vnodes.push({
        vnode,
        binding,
      });
      drzDragula.vnodes = vnodes;
      if (!_.isUndefined(binding.value) && binding.value.isContainer) {
        drzDragula.drake.containers.push(el);
      }
    },
    componentUpdated(el, binding) {
      const c = drzDragula.drake.containers;
      // this is used when disabling/enabling droppable containers at will
      if (!_.isUndefined(binding.value) && binding.value.isContainer) {
        if (!c.includes(el)) {
          // add to containers if isn't there
          c.push(el);
        }
      } else if (!_.isUndefined(binding.value) && !binding.value.isContainer) {
        // remove from containers if there
        if (c.includes(el)) {
          const i = _.findIndex(c, el);
          c.splice(i, 1);
        }
      }
    },
  });
}

export default {
  Tooltip,
  Tabs,
  DropletBubbles,
  Dragula,
};



// WEBPACK FOOTER //
// ./src/directives/main.js